import { useWindowSize } from 'usehooks-ts'
import { AbbauChart_DESK } from './AbbauChart_DESK'
import { AbbauChart_MOBIL } from './AbbauChart_MOBI'

export const AbbauChartt = ({
  hlColor,
  curveColor,
}: {
  hlColor: string
  curveColor: string
}) => {
  const { width } = useWindowSize()
  const isMobile = width < 712

  if (isMobile)
    return <AbbauChart_MOBIL hlColor={hlColor} curveColor={curveColor} />

  return <AbbauChart_DESK hlColor={hlColor} curveColor={curveColor} />
}
